import { useState, useEffect } from "react";
import TableRows from "./TableRows";
import "./TableRow.css";

// A component that allows adding and deleting table rows with attribute name-value pairs
const AddDeleteTableRows = ({ updateRowValues, rowValues }) => {
  const [rowsData, setRowsData] = useState([]);

  // Adds a new empty row to the table
  const addTableRows = () => {
    const rowsInput = {
      attributeName: "",
      attributeValue: "",
    };
    setRowsData([...rowsData, rowsInput]);
  };


  useEffect(() => {
    if (rowValues.length == 0) {
      setRowsData([{ "attributeName": "Total Male", "attributeValue": "" }]);
    }
    else {
      setRowsData(rowValues);
    }

  }, [rowValues]);

  // Deletes a row from the table
  const deleteTableRows = (index) => {
    const rows = [...rowsData];
    rows.splice(index, 1);
    setRowsData(rows);
    updateRowValues(rows);
  };

  // Handles changes to input fields in the table rows
  const handleChange = (index, evnt) => {
    const { name, value } = evnt.target;
    const rowsInput = [...rowsData];
    rowsInput[index][name] = value;
    setRowsData(rowsInput);
    updateRowValues(rowsInput);
  };
  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-12">
          <table className="table dyna_tbl">
            <thead>
              <tr>
                <th style={{ color: "white" }}><label>Name</label></th>
                <th style={{ color: "white" }}><label>Value</label></th>

                <th>
                  <input type="button"
                    className="btn btn-outline-success"
                    onClick={addTableRows}
                    value={"+"}
                  />

                </th>
              </tr>
            </thead>
            <tbody>
              <TableRows
                rowsData={rowsData}
                deleteTableRows={deleteTableRows}
                handleChange={handleChange}
              />
            </tbody>
          </table>
        </div>
        <div className="col-sm-4"></div>
      </div>
    </div>
  );
};
export default AddDeleteTableRows;